import React, { useState } from "react";
import PropTypes from "prop-types";
import HasRolePermission from "components/shared/has-role-permission";
import BulkUnallocateModal from "./modals/bulk-unallocate-modal";
// TODO(v2): Re-enable Bulk Remove from Synthpop once we wire the external
// Synthpop notify. Bulk modal + action creator + BE endpoint preserved so v2
// only needs to put the toolbar button back. See row-action-menu.jsx for the
// single-row variant.
// import BulkRemoveFromSynthpopModal from "./modals/bulk-remove-from-synthpop-modal";
import BulkPostponeModal from "./modals/bulk-postpone-modal";

const SYNTHPOP_DISABLED_TITLE =
  "Deselect Synthpop-allocated rows to enable — bulk actions on Synthpop patients ship in v2.";

const BulkActionsToolbar = ({ selectedRows, clearSelection }) => {
  const [activeModal, setActiveModal] = useState(null);
  if (selectedRows.length === 0) return null;

  const close = () => setActiveModal(null);
  const completeAndClear = () => {
    setActiveModal(null);
    clearSelection();
  };

  // v1: any admin action on a Synthpop-allocated patient would desync our
  // S3_PatientOutreach state from Synthpop's queued task. Disable bulk actions
  // entirely when the selection contains any Synthpop row.
  const synthpopRowCount = selectedRows.filter(
    r => r.outreachState === "AllocatedToSynthpop"
  ).length;
  const disabled = synthpopRowCount > 0;
  const disabledTitle = disabled ? SYNTHPOP_DISABLED_TITLE : undefined;

  return (
    <HasRolePermission allowedRoles={["Administrator"]}>
      <div className="patient-outreach-bulk-toolbar">
        <span className="patient-outreach-bulk-toolbar__count">
          {selectedRows.length} selected
          {disabled && ` (${synthpopRowCount} on Synthpop — actions disabled)`}
        </span>
        <button
          type="button"
          disabled={disabled}
          title={disabledTitle}
          onClick={() => setActiveModal("unallocate")}
        >
          Bulk Deallocate
        </button>
        {/* TODO(v2): Bulk Remove from Synthpop button commented out — see import note above. */}
        <button
          type="button"
          disabled={disabled}
          title={disabledTitle}
          onClick={() => setActiveModal("postpone")}
        >
          Bulk Postpone
        </button>
        <button
          type="button"
          className="patient-outreach-bulk-toolbar__clear"
          onClick={clearSelection}
        >
          Clear selection
        </button>
      </div>
      {activeModal === "unallocate" && (
        <BulkUnallocateModal
          selectedRows={selectedRows}
          onClose={close}
          onComplete={completeAndClear}
        />
      )}
      {activeModal === "postpone" && (
        <BulkPostponeModal
          selectedRows={selectedRows}
          onClose={close}
          onComplete={completeAndClear}
        />
      )}
    </HasRolePermission>
  );
};

BulkActionsToolbar.propTypes = {
  selectedRows: PropTypes.array.isRequired,
  clearSelection: PropTypes.func.isRequired
};

export default BulkActionsToolbar;
